<nz-descriptions [nzBordered]="true">
  <nz-descriptions-item [nzTitle]="'Item No.' | locale">{{itemCode}}</nz-descriptions-item>
  <nz-descriptions-item [nzTitle]="'Description' | locale">{{itemDescription}}</nz-descriptions-item>
  <nz-descriptions-item [nzTitle]="'Customer No.' | locale">{{cardCode}}</nz-descriptions-item>
  <nz-descriptions-item [nzTitle]="'Customer Name' | locale">{{cardName}}</nz-descriptions-item>
</nz-descriptions>

<nz-table #basicTable [nzData]="priceHistory" [nzLoading]="isLoading" [nzSize]="'middle'" nzShowPagination="true">
  <thead>
    <tr>
      <th>Order Date</th>
      <th>Order Number</th>
      <th>Item Code</th>
      <th>Item Description</th>
      <th>Unit Price</th>
      <th>Discount (%)</th>
      <th>Net Unit Price</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let record of basicTable.data">
      <td>{{ record.DocDate }}</td>
      <td>{{ record.DocNum }}</td>
      <td>{{ record.ItemCode }}</td>
      <td>{{ record.Dscription }}</td>
      <!--<td>{{ record.quantityOrdered }}</td>
       <td>{{ record.currency }}</td> -->
      <td>{{ record.PriceBefDi }}</td>
      <td>{{ record.DiscPrcnt }}%</td>
      <td>{{ record.Price }}</td>
      <!-- <td>{{ record.lineTotal | currency: record.currency }}</td> -->
      <!-- <td>{{ record.orderStatus }}</td> -->
    </tr>
  </tbody>
</nz-table>

<nz-alert *ngIf="error" nzType="error" [nzMessage]="error" nzShowIcon></nz-alert>
